import React, { useState } from "react";
import { Table, Button, Input, Space, } from 'antd';
import strings from '../../utils/strings';

import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import moment from 'moment-jalaali'
import { usePersistedStore } from "../../store/persisted-store";

export default function PaidTable() {
    const { business } = usePersistedStore();
    const data = business.agentPaid.paidList;
    const loading = business.agentPaid.loading;

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>
                        جستجو
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>ریست</Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (text),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const columns = [
        {
            title: "کاربر ثبت کننده",
            dataIndex: "SubmitterUserName",
            key: "SubmitterUserName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.SubmitterUserName ? first = a.SubmitterUserName : first = '';
                b.SubmitterUserName ? second = b.SubmitterUserName : second = '';
                return first.length - second.length
            },
            ellipsis: true,
            ...getColumnSearchProps('SubmitterUserName', 'کاربر ثبت کننده'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.Username ? first = a.Username : first = '';
                b.Username ? second = b.Username : second = '';
                return first.length - second.length
            },
            ellipsis: true,
            ...getColumnSearchProps('UserName', 'نام کاربری'),
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: "شماره شبا",
            dataIndex: "AccountNumber",
            key: "AccountNumber",
            ...getColumnSearchProps('AccountNumber', 'شماره شبا'),
            render: data => data && strings.getFarsiNum(data)
        },
        {
            title: "شماره موبایل",
            dataIndex: "MobileNumber",
            key: "MobileNumber",
            ...getColumnSearchProps('MobileNumber', 'شماره موبایل'),
            render: data => data && strings.getFarsiNum(data)
        },
        {
            title: "مبلغ",
            dataIndex: "Amount",
            key: "Amount",
            ...getColumnSearchProps('Amount', 'مبلغ'),
            sorter: (a, b) => a.SumPaid.toString().length - b.SumPaid.toString().length,
            render: data => strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "کد پرداخت",
            dataIndex: "RequestCheckoutPaymentCode",
            key: "RequestCheckoutPaymentCode",
            ...getColumnSearchProps('RequestCheckoutPaymentCode', 'کد پرداخت')
        },
        {
            title: 'تاریخ پرداخت',
            dataIndex: 'PayDate',
            key: 'PayDate',
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            key: "Description",
            ...getColumnSearchProps('Description', 'کد پرداخت')
        },
    ];

    return (
        <Table
            style={{ overflowX: 'scroll' }}
            className="custom-table"
            size="middle"
            bordered
            columns={columns}
            loading={loading}
            rowKey="RequestCheckoutPaymentCode"
            dataSource={data}
            scroll={true}
        />
    );
}